var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-backtop',{attrs:{"target":"#app"}},[_c('span',[_vm._v("test_up_text")])])}
var staticRenderFns = []

export { render, staticRenderFns }